import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CustomCookieService } from '@uc/shared/authentication';
import { BookEvent, BookEventGAService } from '@uc/web/analytics';
import {
	WriteReviewBtnComponent,
	VisitWebsiteBtnComponent,
} from '@uc/web/shared/buttons';
import { Product } from '@uc/shared/data-models';
import { UniversityEvent } from '@uc/web/shared/data-models';
import { BookEventBtnComponent } from '@uc/web/shared/features/feature-book-event';

@Component({
	selector: 'uc-cta-open-days-btns',
	templateUrl: './cta-open-days-btns.component.html',
	imports: [
		WriteReviewBtnComponent,
		BookEventBtnComponent,
		VisitWebsiteBtnComponent,
		RouterLink,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaOpenDaysBtnsComponent {
	isFeatured = input.required<boolean>();
	featuredEvent = input.required<UniversityEvent | null>();
	uniId = input.required<number>();
	uniSlug = input.required<string>();
	product = input.required<Product>();
	uniName = input.required<string>();
	ugSearchOrderPosition = input.required<number | null>();
	privacyPolicyUrl = input.required<string | null>();
	externalUrl = input<string>('');
	externalEventsUrl = input<string>('');
	componentName = input<string>('');
	currentYear = new Date().getFullYear();

	private _userId = this._customCookieSrv.get('user_id');

	constructor(
		private _bookEventGASrv: BookEventGAService,
		private _customCookieSrv: CustomCookieService,
	) {}

	onBookEventClick() {
		const args: BookEvent = {
			uniId: this.uniId(),
			uniName: this.uniName(),
			componentName: this.componentName(),
			eventType: this.featuredEvent()?.type,
			date: this.featuredEvent()?.date,
			ugSearchOrderPosition: this.ugSearchOrderPosition(),
			isUser: this._userId ? true : false,
		};
		this._bookEventGASrv.bookEventClick(args);
	}
}
